var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page-sticky',{staticClass:"z-fab",attrs:{"offset":[18, 18]}},[_c('q-btn',{attrs:{"type":"submit","fab":"","color":"positive","icon":"fa fa-check"},on:{"click":function($event){return _vm.$emit('submit')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }